import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getCultivationUnitList as getCultivationUnitListApi,
	getCultivationUnitListQuery as getCultivationUnitListQueryApi,
	getCultivationUnit as getCultivationUnitApi,
	addNewCultivationUnitApi,
	updateCultivationUnitApi,
	deleteCultivationUnitApi,
	checkCultivationUnitExistsApi,
} from '../../helpers/cultivation_unit/api_helper';

export const getCultivationUnitList = createAsyncThunk(
	'cultivationUnit/getCultivationUnitList',
	async () => {
		try {
			const response = await getCultivationUnitListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las unidades de cultivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getCultivationUnitListQuery = createAsyncThunk(
	'cultivationUnit/getCultivationUnitListQuery',
	async params => {
		try {
			const response = getCultivationUnitListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getCultivationUnit = createAsyncThunk(
	'cultivationUnit/getCultivationUnit',
	async cultivation_unit_id => {
		try {
			const response = await getCultivationUnitApi(cultivation_unit_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la unidad de cultivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewCultivationUnit = createAsyncThunk(
	'cultivationUnit/addNewCultivationUnit',
	async cultivation_unit => {
		try {
			const response = await addNewCultivationUnitApi(cultivation_unit);
			toast.success('Unidad de Cultivo agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la unidad de cultivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateCultivationUnit = createAsyncThunk(
	'cultivationUnit/updateCultivationUnit',
	async cultivation_unit => {
		try {
			const response = await updateCultivationUnitApi(cultivation_unit);
			toast.success('Unidad de Cultivo actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la unidad de cultivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteCultivationUnit = createAsyncThunk(
	'cultivationUnit/deleteCultivationUnit',
	async cultivation_unit => {
		try {
			const response = await deleteCultivationUnitApi(cultivation_unit._id);
			toast.success('Unidad de Cultivo eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return cultivation_unit;
		} catch (error) {
			toast.error('Error al eliminar la unidad de cultivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkCultivationUnitExists = createAsyncThunk(
	'cultivationUnit/checkCultivationUnitExists',
	async name => {
		try {
			const response = await checkCultivationUnitExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
